import { Badge, Flex, Text } from '@radix-ui/themes'
import {
  comparedBeforeTelemetrySettled,
  isScaleError,
  verdictOf,
  type AlignmentVerdict as Verdict,
  type CaptureDetail
} from '~/features/index-captures/alignment'
import { outcomeLabel } from '~/features/index-captures/labels'
import { ScaleErrorBadge } from './CaptureBadges'

const VERDICT_COLOR: Record<Verdict, 'green' | 'red' | 'gray'> = {
  aligned: 'green',
  not_aligned: 'red',
  pending: 'gray'
}

const headline = (verdict: Verdict, overridden: boolean): string => {
  if (verdict === 'aligned') return overridden ? 'Aligned — accepted by ops' : 'Aligned'
  if (verdict === 'not_aligned') return overridden ? 'Not aligned — confirmed by ops' : 'Not aligned'
  return 'Photo received — compared at the next hourly run'
}

export const AlignmentVerdict = ({ detail }: { detail: CaptureDetail }) => {
  const { verdict, overridden } = verdictOf(detail)
  const color = VERDICT_COLOR[verdict]

  return (
    <Flex direction="column" gap="2">
      <Flex align="center" gap="2" wrap="wrap">
        <Badge color={color} variant="soft" size="2">
          {headline(verdict, overridden)}
        </Badge>
        {detail.outcome && detail.outcome !== 'match' ? (
          <Badge color={color} variant="outline" size="2">
            {outcomeLabel[detail.outcome]}
          </Badge>
        ) : null}
        {isScaleError(detail) ? <ScaleErrorBadge size="2" /> : null}
      </Flex>

      {detail.status === 'flagged' && comparedBeforeTelemetrySettled(detail) ? (
        <Text size="2" color="amber">
          Compared less than a day after the photo was taken, so telemetry may not have reached the data lake yet.
          Compare again tomorrow before overriding.
        </Text>
      ) : null}
    </Flex>
  )
}
